// src/services/profileGuard.js

/**
 * Checks whether an applicant's core profile metrics are populated.
 * Uses exact case matching against the production Users database schema.
 */
export const isProfileIncomplete = (profileData) => {
    if (!profileData) return true;

    // Use exact keys returned by SELECT * FROM Users database query
    const firstNames = profileData.FirstNames || '';
    const surname = profileData.Surname || '';
    const idNumber = profileData.IdNumber || '';
    const gender = profileData.Gender || '';

    const fNameClean = String(firstNames).trim();
    const sNameClean = String(surname).trim();
    const idClean = String(idNumber).trim();
    const genderClean = String(gender).trim().toLowerCase();

    // The user is ONLY blocked if these primary fields are missing or explicitly string 'null'
    const isInvalid = 
        !fNameClean || fNameClean === 'null' ||
        !sNameClean || sNameClean === 'null' ||
        !idClean || idClean === 'null' ||
        !genderClean || genderClean === 'null' || genderClean === 'undefined';

    return isInvalid;
};